import { useCallback } from 'react';
import { useAtom } from 'jotai';
import * as state from '@/state';
import { PointBudgetSlider } from '../PointBudgetSlider';
import { ToggleItemVisibility } from '@/components/Analysis/Viewer/Panels/Visibility/ToggleItemVisibility';
import { useFeatureFlag } from '@/hooks';

export const PointBudgetControls = () => {
  const [enableAdaptivePointBudget, setEnableAdaptivePointBudget] = useAtom<boolean>(
    state.enableAdaptivePointBudget
  );

  const isBetaUser = useFeatureFlag('beta-user');

  const toggleAdaptivePointBudget = useCallback(() => {
    setEnableAdaptivePointBudget((current) => {
      return !current;
    });
  }, [setEnableAdaptivePointBudget]);

  return (
    <>
      {isBetaUser && (
        <ToggleItemVisibility
          label="Adaptive Point Budget"
          isVisible={enableAdaptivePointBudget}
          toggleVisibility={toggleAdaptivePointBudget}
        />
      )}

      {!enableAdaptivePointBudget && (
        <PointBudgetSlider title="Point budget" step={500_000} min={2_000_000} max={40_000_000} />
      )}
    </>
  );
};
